module.exports = __webpack_public_path__ + "statics/img/ycz3m.ec46082c.png";